export default __webpack_public_path__ + "static/media/Animals_17.21abf5a3.png";